// Module-level event bus between the Apollo link (outside React) and the
// DevProfilerContext (inside React). No React dependency here.

export interface GqlTrace {
  id: string
  operationName: string
  operationType: 'query' | 'mutation' | 'subscription'
  variables: Record<string, unknown>
  query: string
  response: { data?: unknown; errors?: unknown[] } | null
  durationMs: number
  timestamp: string
}

type Listener = (trace: GqlTrace) => void

const listeners = new Set<Listener>()

export function subscribeToGqlTraces(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function emitGqlTrace(trace: GqlTrace): void {
  listeners.forEach((l) => l(trace))
}
